import React, { useEffect, useState } from "react";
import useCustomParams from '../hooks/useCustomParams';
import { Api } from "../api/Api";
import PageHeader from "../components/PageHeader";
import { DatePicker, Select, Spin } from "antd";
import '../styles/appointments.css';
import useCustomNavigate from "../hooks/useCustomNavigate";
import { showToast } from "../helpers/UIHelper";
import dayjs from 'dayjs';
const Appointments = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [sessionId, setSessionId] = useState(null);
    const { departmentId, isSpeciality, departmentName } = useCustomParams();
    const [sessions, setSessions] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [doctors, setDoctors] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const navigate = useCustomNavigate();
    const disabledDate = (current) => {
        return current && current < dayjs().startOf('day');
    };

    useEffect(() => {
        Promise.all([Api.get('/api/MobileHospitalHolidaylist/'), Api.get(`/api/getSessionsAppointments/?siteid=2&departmentId=${departmentId}&isspeciality=${isSpeciality}`)]).then(([holiResp, response]) => {
            if (holiResp.data.holidaylist.length!==0) {
                setHolidays(holiResp.data.holidaylist);
            }    
            if (response.data && response.data.sessions) {
                //console.log(response.data.sessions);
                const processedSessions = response.data.sessions.map((session) => {
                    return {
                        label: `${session.sessionname}`,
                        value: session.sessionid,
                    };
                });
                setSessions(processedSessions);
                setSessionId(response.data.sessions[0].sessionid); 
            } else {
                showToast('error', 'No sessions found');
                setIsLoading(false);
            }
        })
        .catch((e) => {
            showToast('error','Error finding sessions.');
            console.error('Error fetching sessions:', e);
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
        });
        // eslint-disable-next-line
    },[]);
    const fetchDoctors = (sessId, date) => {
        if (!date || !sessId) {
            setDoctors([]);
            return
        }
        setIsLoading(true);
        const formattedDate = date.format('DD/MM/YYYY');
        if (isHoliday(formattedDate)) {
            showToast('error','The selected date is a hospital holiday.');
            setIsLoading(false);
            setDoctors([]);
            return;
        }
        Api.get(`/api/mobileConslutantdeptwiseinfo/?deptId=${departmentId}&date=${formattedDate}&isspeciality=${isSpeciality}&sessionId=${sessId}&siteId=2`)
            .then((response) => {
                if (response.data && response.data.Consultant_List) {
                    if (response.data.Consultant_List.length===1) {
                        if (response.data.Consultant_List[0].error) {
                            return;
                        }
                    }
                    setDoctors(response.data.Consultant_List);
                } else {
                    showToast('error','No doctors found.')
                }
            })
            .catch((e) => {
                showToast('error', 'Error finding doctors.');
            }).finally(() => setIsLoading(false));
    };

    const handleDoctorClick = (doctor) => {
        if (doctor.queueno === 0) {
            showToast('error',`No online slots available for ${doctor.consult_name}`);
            return;
        } 
        setIsLoading(true);
        Api.get(`/api/mobileappointdeptunitwiseinfo/?employeeId=${doctor.consult_id}&sessionId=${sessionId}&depid=${departmentId}`).then((resp) => {
            if (resp.status === 200) {
                if (resp.data.Unit_list.length > 0) {
                    var sesName = sessions.find(s => s.value === sessionId);
                    navigate(`/slotbooking`, 
                        {   
                            doctorName: doctor.consult_name,
                            date: selectedDate.format('DD/MM/YYYY'),
                            session: sessionId,
                            sessionName:sesName.label,
                            unitId:resp.data.Unit_list[0].unit_id,
                            departmentid: departmentId,
                            doctorid: doctor.consult_id,
                            drdesignation: doctor.emp_des,
                            deptName : departmentName,
                        });
                } else {
                    showToast('error','Doctor Not Available.');
                } 
                setIsLoading(false);
            }
        }).catch((e) => {
            setIsLoading(false);
        })
    };
    const isHoliday = (date) => {
        for (const holiday of holidays){
            var d = holiday.holiday_date;
            d = d.split(' ')[0];
            var split = d.split('-')
            const actualDate = split[2] + '/' + split[1] + '/' + split[0];

            if (date===actualDate) {
                return true;
            }
        }
        return false;
    }
    return (
        <div className="appointments-page">
            <PageHeader title="Doctor Selection"/>
            <div className="page-sub-title">
                Select Doctor
            </div>
            <div className="date-selection">
                <DatePicker format="DD-MM-YYYY"
                value={selectedDate} 
                disabledDate={disabledDate}    
                    onChange={(date) => { setSelectedDate(date);fetchDoctors(sessionId,date); }} size="middle"
                    className="component" /> 
                <Select options={sessions} value={sessionId}  defaultValue={sessionId} onChange={(value) => { setSessionId(value); fetchDoctors(value,selectedDate); }}></Select>
            </div>
            {!isLoading ?
                <div className="doctors-list">
                    {doctors.map((doctor, index) => (
                        <div className="doctor-item" key={index} onClick={() => { handleDoctorClick(doctor)}}>
                            <div className="doctor-name">
                                <img src={'data:image/jpg;base64,'+doctor.imagebyte} alt={doctor.consult_id} />
                                <div>{doctor.emp_des + ' ' + doctor.consult_name}</div>
                            </div>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                                <div style={{fontSize:'10px',margin:'0 0 0 40px'}}>{doctor.qualification}</div>
                                <div className={doctor.queueno === 0 ? "slot-detail red-text" : "slot-detail"}>{doctor.queueno === 0 ? 'No online slots available.' : `Slots available : ${doctor.queueno}`}</div>
                            </div>
                        </div>
                    ))}
                </div> :
                <div className="loading">
                    <Spin/>
                </div>
            }
        </div>
    )
}
export default Appointments;